import * as React from 'react';
import Button from "@material-ui/core/Button";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import Storage from "src/common/Storage";
import AuthService from '../../services/AuthService'
import { useDispatch } from "react-redux";
import { logout } from "src/redux/actions";

const ButtonB2CAADLogin = ({ tenantConfig, loginType, btnText, tokenRequest, setLoading, domain, onAuth, show = true }) => {

  const isAuthenticated = useIsAuthenticated();
  const dispatch = useDispatch();
  const { accounts, instance, inProgress } = useMsal();

  const handleLoginAAD = async () => {
    try {
      sessionStorage.clear()
      Storage.setLoginType(loginType);
      Storage.setTenant(JSON.stringify(tenantConfig));
      Storage.setDomain(domain);

      await instance.loginRedirect({ ...tokenRequest }).catch((error) => {
        console.log(error)
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleAuthLogin = () => {
    try {

      if (accounts[0].localAccountId) {

        Storage.setLoginType(loginType);
        Storage.setTenant(JSON.stringify(tenantConfig));
        Storage.setDomain(domain);

        instance.acquireTokenSilent({
          scopes: tokenRequest.scopes,
          account: accounts[0]
        }).then((response) => {
          setLoading(true)
          
          if (response) {
            setLoading(true)
            AuthService.loginAD(response.accessToken, 'B2C').then((responseAD) => {
              setLoading(false)
              if (typeof onAuth === 'function') {
                onAuth("B2C", response.accessToken, responseAD)
              }

            }).catch(e => {
              Storage.clear();
              dispatch(logout());
              setLoading(false)
            })
          }
        }).catch(error => {
          if (error.name === "InteractionRequiredAuthError" || error.errorCode === "authority_mismatch") {
            // ต้อง login ใหม่
            instance.logout(); // หรือ logoutRedirect()
          } else {
            console.error(error);
          }
        });

      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }


  React.useEffect(() => {
    if (isAuthenticated && inProgress === 'none') {
      handleAuthLogin()
    }
    // eslint-disable-next-line
  }, [isAuthenticated, inProgress])

  return show ? <Button color='primary' id="login_ad_btn" data-testid={`btn-login-${tenantConfig.clientId}`} variant="contained" fullWidth onClick={() => handleLoginAAD()}>{btnText}</Button> : <></>
}

export default ButtonB2CAADLogin;